import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests.js';
import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';
import { FormLayout, FormSection, FormField, FormLoading } from '../../shared/ui/FormLayout';

const EditVacancyCategoryPage = () => {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!form.title?.trim()) {
      toast.error('Введите название');
      return;
    }
    setSaving(true);
    try {
      await apiRequests.hr.updateCategory(form);
      toast.success('Категория обновлена');
      navigate('/hr/categories');
    } catch (e) {
      toast.error('Ошибка');
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    const getData = () => {
      apiRequests.hr.getCategory(id).then((res) => {
        setForm(res);
      });
    };
    getData();
  }, []);

  if (!form) return <FormLoading />;

  return (
    <FormLayout
      onSubmit={handleSubmit}
      onBack={() => navigate('/hr/categories')}
      saving={saving}
      submitText="Сохранить"
    >
      <FormSection title="Основная информация">
        <FormField label="Название" required>
          <Form.Control
            type="text"
            value={form.title}
            onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
            placeholder="Введите название"
            style={{ maxWidth: '400px' }}
          />
        </FormField>
      </FormSection>
    </FormLayout>
  );
};

export default EditVacancyCategoryPage;
